import authAxios from '../config/authAxios';
import { avisoError } from '../view/components/AvisosMensajes/MensajesSwalf';

export const KPIS_AC_LOADING    = 'KPIS_AC_LOADING';
export const KPIS_AC_OBTENIDO   = 'KPIS_AC_OBTENIDO';
export const KPIS_AC_ERROR      = 'KPIS_AC_ERROR';
export const KPIS_AC_PRODS_OK   = 'KPIS_AC_PRODS_OK';
export const KPIS_AC_DOCENTES_OK = 'KPIS_AC_DOCENTES_OK';

export const obtenerKpisAcademicos = (anio, mes, id_proyecto = null, id_docente = null) => async dispatch => {
  dispatch({ type: KPIS_AC_LOADING });
  try {
    const params = { anio, mes };
    if (id_proyecto) params.id_proyecto = id_proyecto;
    if (id_docente)  params.id_docente  = id_docente;
    const res = await authAxios.get('/admin/kpis-academicos', { params });
    dispatch({ type: KPIS_AC_OBTENIDO, payload: res.data });
  } catch (e) {
    dispatch({ type: KPIS_AC_ERROR });
    avisoError('Error al obtener los KPIs académicos');
  }
};

export const obtenerProductosKpi = (anio, mes) => async dispatch => {
  try {
    const res = await authAxios.get('/admin/kpis-academicos/productos', {
      params: { anio, mes }
    });
    dispatch({ type: KPIS_AC_PRODS_OK, payload: res.data });
  } catch (e) {
    // silencioso — no bloquea el reporte
  }
};

export const obtenerDocentesKpi = (anio, mes, id_proyecto = null) => async dispatch => {
  try {
    const params = { anio, mes };
    if (id_proyecto) params.id_proyecto = id_proyecto;
    const res = await authAxios.get('/admin/kpis-academicos/docentes', { params });
    dispatch({ type: KPIS_AC_DOCENTES_OK, payload: res.data });
  } catch (e) {
    // silencioso
  }
};
